function timeline(){
  let owl = $('.timeline__slider');
  owl.owlCarousel({
    items:8,
    dots:false,
    loop:false,
    nav: true,
    mouseDrag: false,
    touchDrag: false,
    navText: ['<svg class="timeline__arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 13"><line class="cls-1" x1="21.5" y1="6.5" x2="0.5" y2="6.5"/><polyline class="cls-1" points="6.5 0.5 0.5 6.5 6.5 12.5"/></svg>','<svg class="timeline__arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 13"><line class="cls-1" x1="0.5" y1="6.5" x2="21.5" y2="6.5"/><polyline class="cls-1" points="15.5 0.5 21.5 6.5 15.5 12.5"/></svg>'],
    responsive:{
      0 : {
        items: 1
      },
      480: {
        items: 2
      },
      768: {
        items: 3
      },
      992: {
        items: 5
      },
      1200:{
        items: 8
      }
    }
  });

  $('.timeline__btn').on('click', function() {
    $('.timeline__btn').removeClass('active');
    $('.timeline__text').removeClass('active');
    const id = $(this).attr('data-timline-id');
    if(!$(this).hasClass('active')) {
      $(this).addClass('active');
      $('.timeline__text[data-timline-id="'+id+'"]').addClass('active');
    } 
  });
};

export default timeline;